module.exports = {
    "dismiss": `Avvisa`
};


//# sourceMappingURL=sv-SE.main.js.map
